import { render, staticRenderFns } from "./EditTaxObligationModal.vue?vue&type=template&id=2ad57136&"
import script from "./EditTaxObligationModal.vue?vue&type=script&lang=ts&"
export * from "./EditTaxObligationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports